import { PageView } from '../../components/Analytics/PageView/PageView'
import { useEffect, useState,useMemo } from "react"
import ReactHtmlParser from 'react-html-parser'
import { TextAPI } from '../../api/TextAPI'
import Head from 'next/head';

const title = "PRIVACY POLICY"
const textType = 'privacy_policy'

export default function PrivacyPolicy() {

  const [ bodyText, setBodyText ] = useState("")

  const textAPI = useMemo(() => new TextAPI(process.env.NEXT_PUBLIC_API_BASE_URL ?? ''), [])

  useEffect(() => {
    textAPI.getByType(textType).then(text => text && setBodyText(text.body))
  }, [textAPI])

  return (
    <main>
      <Head key={'privacy-policy'}><title>Universal Orlando™ | Privacy policy</title></Head>
      <PageView
        pageName='Privacy Policy'
      />
      <h1>{title}</h1>
      { ReactHtmlParser(bodyText) }
      <button id="ot-sdk-btn" className="ot-sdk-show-settings">Cookie Settings</button>
      {<div id="ot-sdk-cookie-policy"></div>}
    </main>
  )
}
